module.exports = __webpack_public_path__ + "img/balkam-numbers.3aba92b3.gif";